import { createContext } from "react";
import { CheatMenuDialog } from "../components/dialogs/CheatDialog";
import React from "react";
import SignInSignUpDialog from "../components/dialogs/SignInSignUpDialog";
import { DeleteDialog } from "../components/dialogs/DeleteDialog";
import { OfflineProgressDialog } from "../components/dialogs/OfflineProgressDialog";
import { GameContext } from "./GameProvider";
import { MoleculeCreationDialog } from "../components/dialogs/MoleculeCreationDialog";
import HelpDialog from "../components/dialogs/HelpDialog";

export const DialogContext = createContext({
  cheatDialogOpen: false,
  setCheatDialogOpen: (value: React.SetStateAction<boolean>) => {},
  signInSignUpDialogOpen: false,
  setSignInSignUpDialogOpen: (value: React.SetStateAction<boolean>) => {},
  signDialogType: "login" as "login" | "signup",
  setSignDialogType: (value: React.SetStateAction<"login" | "signup">) => {},
  deleteDialogOpen: false,
  setDeleteDialogOpen: (value: React.SetStateAction<boolean>) => {},
  createMoleculeDialogOpen: false,
  setCreateMoleculeDialogOpen: (value: React.SetStateAction<boolean>) => {},
  helpDialogOpen: false,
  setHelpDialogOpen: (value: React.SetStateAction<boolean>) => {},
});

export const DialogProvider = ({ children }: { children: any }) => {
  const { offlineDiff, setOfflineDialogOpen, offlineDialogOpen } =
    React.useContext(GameContext);
  const [cheatDialogOpen, setCheatDialogOpen] = React.useState(false);
  const [signInSignUpDialogOpen, setSignInSignUpDialogOpen] =
    React.useState(false);
  const [signDialogType, setSignDialogType] = React.useState<
    "login" | "signup"
  >("login");
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [createMoleculeDialogOpen, setCreateMoleculeDialogOpen] =
    React.useState(false);
  const [helpDialogOpen, setHelpDialogOpen] = React.useState(false);

  return (
    <DialogContext.Provider
      value={{
        cheatDialogOpen,
        setCheatDialogOpen,
        signInSignUpDialogOpen,
        setSignInSignUpDialogOpen,
        signDialogType,
        setSignDialogType,
        deleteDialogOpen,
        setDeleteDialogOpen,
        createMoleculeDialogOpen,
        setCreateMoleculeDialogOpen,
        helpDialogOpen,
        setHelpDialogOpen,
      }}
    >
      <OfflineProgressDialog
        open={offlineDialogOpen}
        setOpen={setOfflineDialogOpen}
        diff={offlineDiff}
      />
      <CheatMenuDialog open={cheatDialogOpen} setOpen={setCheatDialogOpen} />
      <SignInSignUpDialog
        open={signInSignUpDialogOpen}
        onClose={() => setSignInSignUpDialogOpen(false)}
        type={signDialogType}
      />
      <DeleteDialog open={deleteDialogOpen} setOpen={setDeleteDialogOpen} />
      <MoleculeCreationDialog
        open={createMoleculeDialogOpen}
        setOpen={setCreateMoleculeDialogOpen}
      />
      <HelpDialog open={helpDialogOpen} setOpen={setHelpDialogOpen} />
      {children}
    </DialogContext.Provider>
  );
};
